import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/auth-store';
import { tryRestoreSession } from '../lib/api';

/**
 * Wrapper que protege rutas. Si no hay accessToken intenta restaurar sesión
 * desde la cookie refresh (HttpOnly). Si falla, redirige a /login preservando
 * la URL solicitada en `location.state.from` para volver tras el login.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken);
  const [checked, setChecked] = useState(accessToken !== null);
  const location = useLocation();

  useEffect(() => {
    if (accessToken) {
      setChecked(true);
      return;
    }
    tryRestoreSession().finally(() => setChecked(true));
  }, [accessToken]);

  if (!checked) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50">
        <div className="text-sm text-slate-500">Cargando sesión…</div>
      </div>
    );
  }

  if (!useAuthStore.getState().accessToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
